/** Cmdk always highlights a row; this value targets a hidden item so no visible row looks active. */
export const CMDK_NO_HIGHLIGHT = '__dropdown-select-no-highlight__'

/** A nested item's left padding from the 1st level down, a checkbox width more each. Deeper levels keep the last. */
export const NESTED_ITEM_PADDING = ['pl-6', 'pl-10', 'pl-14']
